import { createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import {
  deleteAdvisor,
  editBranch,
  editEmailRouting,
  getBranchesByTenant,
  getBranchesUsers,
  getEmailsByBranches,
  saveAdvisors,
  saveBranch,
} from "./thunks";

const initialState = {
  branchesByTenants: {},
  loading: true,
  branchUsersLoading: true,
};

const branchSlice = createSlice({
  name: "branch",
  initialState,
  reducers: {
    setKeyValue: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBranchesByTenant.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBranchesByTenant.fulfilled, (state, action) => {
        const { data, tenant_id } = action.payload;
        state.branchesByTenants[tenant_id] = data;
        state.loading = false;
      })
      .addCase(getBranchesByTenant.rejected, (state) => {
        state.loading = false;
      })
      .addCase(saveBranch.fulfilled, (state, action) => {
        const { data, message: successMessage } = action.payload;
        state.branchesByTenants[data?.tenant_id].push(data);
        message.success(successMessage || "Branch added successfully!");
      })
      .addCase(editBranch.fulfilled, (state, action) => {
        const { data, message: successMessage } = action.payload;

        const branches = state.branchesByTenants[data?.tenant_id];
        const index = branches.findIndex((b) => b.id === data.id);
        if (index !== -1) {
          branches[index] = data;
          message.success(successMessage || "Branch updated successfully!");
        }
      })
      .addCase(editEmailRouting.fulfilled, (state, action) => {
        const { data, message: successMessage } = action.payload;
        const { tenant_id, branch_id } = action.meta.arg;

        const branches = state.branchesByTenants?.[tenant_id];

        if (!branches) return;

        const branch = branches?.find((b) => b.id === branch_id);

        if (branch?.emails) {
          branch.emails = [data, ...(branch.emails || [])];
        }
        message.success(
          successMessage || "Branch Email Routing Created Successfully!",
        );
      })
      .addCase(getBranchesUsers.pending, (state) => {
        state.branchUsersLoading = true;
      })
      .addCase(getBranchesUsers.fulfilled, (state, action) => {
        const { data, tenant_id } = action.payload;
        state.branchesByTenants[tenant_id]?.forEach((branch) => {
          branch.users =
            data.filter(({ branch_id }) => branch_id === branch?.id) || [];
        });
        state.branchUsersLoading = false;
      })
      .addCase(saveAdvisors.fulfilled, (state, action) => {
        const { data, tenant_id, message: successMessage } = action.payload;
        state.branchesByTenants[tenant_id]?.forEach((branch) => {
          branch.users = [
            ...branch?.users,
            ...(data.filter(({ branch_id }) => branch_id === branch?.id) || []),
          ];
        });
        message.success(successMessage || "Advisor added successfully");
      })
      .addCase(deleteAdvisor.fulfilled, (state, action) => {
        const {
          user_ids,
          branch_id,
          tenant_id,
          message: successMessage,
        } = action.payload;
        state.branchesByTenants[tenant_id]?.forEach((branch) => {
          if (branch_id !== branch?.id) return;
          branch.users =
            branch?.users.filter(
              ({ user_id }) => !user_ids?.includes(user_id),
            ) || [];
        });
        message.success(successMessage || "Advisor removed Successfully");
      })
      .addCase(getEmailsByBranches.fulfilled, (state, action) => {
        const { data } = action.payload;
        const { tenant_id, branch_id } = action.meta.arg;

        const branches = state.branchesByTenants?.[tenant_id];
        if (!branches) return;

        const branch = branches.find((b) => b.id === branch_id);
        if (branch) branch.emails = data || [];
      });
  },
});

export const { setKeyValue } = branchSlice.actions;

export default branchSlice.reducer;
